
















import Vue from 'vue';
import { BNavbar, BContainer, BNavbarBrand, BNavbarToggle, BNavbarNav, BCollapse } from 'bootstrap-vue';
import SectionBar from '@/components/SectionBar.vue';

export default Vue.extend({
  components: { BNavbar, BContainer, BNavbarBrand, BNavbarToggle, BNavbarNav, BCollapse, SectionBar },
});
